import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import * as yup from "yup";
import { useResetUserPasswordMutation } from "../../../utils/api/auth/auth.api";
import {
  ForgetPasswordFormData,
  ResetPasswordFormData,
} from "../../../utils/api/auth/auth.type";
import { Color } from "../../../utils/theme";
import {
  cleannerError,
  countCharacters,
  countLowercase,
  countNumber,
  countSpecial,
  countUppercase,
  validatePassword,
} from "../../../utils/Utils";

export function UseResetPasswordForm(openModalConnexionPassword?: () => void) {
  const [resetPassword, { error, isSuccess, isLoading }] =
    useResetUserPasswordMutation();

  const state = useLocation().state as ForgetPasswordFormData;

  const navigate = useNavigate();

  const validationSchema = useMemo(
    () =>
      yup.object().shape({
        telephone: yup.string().required().label("telephone"),
        code: yup.string().required().label("Code"),
        new_password: validatePassword(yup),
        new_password_confirm: yup
          .string()
          .oneOf(
            [yup.ref("new_password"), ''],
            "Les mots de passe ne correspond pas"
          ),
      }),
    []
  );

  const {
    register,
    handleSubmit,
    formState: { errors },
    clearErrors,
    setValue,
    setError,
  } = useForm<ResetPasswordFormData>({
    resolver: yupResolver(validationSchema),
  });
  const [password, setPassword] = useState("");
  const [haveMinUppercase, setHaveMinUppercase] = useState(false);
  const [haveMinLowercase, setHaveMinLowercase] = useState(false);
  const [haveMinNumber, setHaveMinNumber] = useState(false);
  const [haveMinCharacter, setHaveMinCharacter] = useState(false);
  const [haveMinSpecialCharacter, setHaveMinSpecialCharacter] = useState(false);
  const [code, setCode] = useState<string>("");
  const [phone, setPhone] = useState<string>("");

  const passwordHandleChange = (e: any) => {
    var password = e.target.value;
    setPassword(password);
    if (countUppercase(password)) {
      setHaveMinUppercase(true);
    } else {
      setHaveMinUppercase(false);
    }
    if (countLowercase(password)) {
      setHaveMinLowercase(true);
    } else {
      setHaveMinLowercase(false);
    }
    if (countNumber(password)) {
      setHaveMinNumber(true);
    } else {
      setHaveMinNumber(false);
    }
    if (countCharacters(password)) {
      setHaveMinCharacter(true);
    } else {
      setHaveMinCharacter(false);
    }
    if (countSpecial(password)) {
      setHaveMinSpecialCharacter(true);
    } else {
      setHaveMinSpecialCharacter(false);
    }

    setValue("new_password", e.target.value);
  };

  const handleChangePhone = (item, country) => {
    setCode(country?.countryCode);
    setPhone("+" + item);
    if (parseInt(item) !== parseInt(country?.dialCode)) {
      setValue("telephone", "+" + item);
    } else {
      setValue("telephone", "");
    }
  };

  useEffect(() => {
    if (error) {
      const err = error as any;
      const message =
        err?.data?.error || `Une erreur de statut ${err?.status} est survenue.`;
      setError("code", { message: message });
    }
  }, [error]);

  useEffect(() => {
    if (isSuccess) {
      Swal.fire({
        icon: "success",
        iconColor: Color.success,
        confirmButtonColor: Color.success,
        title: "Mot de passe modifié avec succès!",
        text: "Voulez-vous vous déconnecter pour vous reconnecter avec votre nouveau mot de passe ?",
        showCancelButton: true,
        confirmButtonText: "Oui, me déconnecter",
        cancelButtonText: "Non, rester connecté",
        reverseButtons: true,
      }).then(async (result) => {
        if (result?.isConfirmed) {
          // Déconnexion
          if (openModalConnexionPassword) {
            await navigate("/", { state: "open", replace: true });
            // await openModalConnexionPassword()
          } else {
            navigate("/connexion");
          }
        } else {
          // Rester connecté, rediriger vers Mon profil
          navigate("/mon-compte/profil");
        }
      });
    }
  }, [isSuccess]);

  useEffect(() => {
    if (errors) {
      cleannerError(errors, clearErrors, 3000);
    }
  }, [errors]);
  return {
    register,
    errors,
    onSubmit: handleSubmit(resetPassword),
    clearErrors,
    isLoading,
    passwordHandleChange,
    haveMinCharacter,
    haveMinLowercase,
    haveMinNumber,
    haveMinSpecialCharacter,
    haveMinUppercase,
    handleChangePhone,
    phone,
  };
}
